module.exports = __webpack_public_path__ + "static/img/01best.7341ec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/sport/07sportIndex/01best.png
// module id = W72q
// module chunks = 0